import styled from 'styled-components';

export const ProgressWrapper = styled.div`
  margin-left: 40px;
`;
export const Title = styled.div.attrs({ className: 'hl3' })`
  height: 100%;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.baseBlue.a10};
`;

export const Section = styled.div`
  margin-top: 30px;
`;

export const ButtonWrapper = styled(Section)`
  margin-left: 40px;
`;

export const ChipsWrapper = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
`;

export const EditHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: ${({ theme }) => theme.baseBlue.a10};
  > span {
    margin-left: 15px;
  }
  > div {
    cursor: pointer;
    transform: rotate(180deg);
  }
`;

export const IconWrapper = styled.div`
  color: ${({ theme }) => theme.baseBlue.a6};
  cursor: pointer;
  padding: 5px;
  &:hover {
    color: ${({ theme }) => theme.baseBlue.a10};
  }
`;

export const EditSection = styled.div`
  display: flex;
`;
